import { render } from "./WalletWithdraw.vue?vue&type=template&id=48f147c2"
import script from "./WalletWithdraw.vue?vue&type=script&lang=js"
export * from "./WalletWithdraw.vue?vue&type=script&lang=js"

import "./WalletWithdraw.vue?vue&type=style&index=0&id=48f147c2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__